import { render, staticRenderFns } from "./MaterialWarehouselist.vue?vue&type=template&id=1becf8a4&"
import script from "./MaterialWarehouselist.vue?vue&type=script&lang=js&"
export * from "./MaterialWarehouselist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports